/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

export default [
  {
    path: '/login',
    name: 'login',
    view: 'auth/Login'
  },
  {
    path: '/logout',
    name: 'logout',
    view: 'auth/Logout'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    // Relative to /src/views
    view: 'Dashboard',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/graficas/personas',
    name: 'graficasPersonas',
    // Relative to /src/views
    view: 'Graficas/Personas',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/graficas/comparativas',
    name: 'graficasComparativas',
    // Relative to /src/views
    view: 'Graficas/Comparativas',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/graficas/datos',
    name: 'insertarDatosGraficas',
    // Relative to /src/views
    view: 'Graficas/Datos',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/graficas/empleados',
    name: 'empleados',
    // Relative to /src/views
    view: 'Graficas/Empleados',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/recogidas',
    name: 'recogidas',
    // Relative to /src/views
    view: 'Graficas/Recogidas',
    meta: {
      requiresAuth: true,
    }
  }
  
  
  
  
  
  
  
  
  
  ,
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'
  },
  {
    path: '/typography',
    view: 'Typography'
  },
  {
    path: '/icons',
    view: 'Icons'
  },
  {
    path: '/maps',
    view: 'Maps'
  },
  {
    path: '/notifications',
    view: 'Notifications'
  },
  {
    path: '/upgrade',
    name: 'Upgrade to PRO',
    view: 'Upgrade'
  }
]
